var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlancH2C(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 525.89 279.89",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        filter: url(#drop-shadow-5);\n      }\n\n      .cls-2, .cls-3, .cls-4, .cls-5, .cls-6 {\n        stroke-miterlimit: 10;\n      }\n\n      .cls-2, .cls-3, .cls-5 {\n        fill: none;\n      }\n\n      .cls-2, .cls-5 {\n        stroke-width: .75px;\n      }\n\n      .cls-2, .cls-6 {\n        stroke: #e63d11;\n      }\n\n      .cls-7 {\n        fill: url(#Blanc_Noir);\n        opacity: .5;\n      }\n\n      .cls-7, .cls-8, .cls-9, .cls-10, .cls-11 {\n        mix-blend-mode: multiply;\n      }\n\n      .cls-12, .cls-6 {\n        fill: #e63d11;\n      }\n\n      .cls-3 {\n        stroke-width: 7px;\n      }\n\n      .cls-3, .cls-4, .cls-5 {\n        stroke: #fff;\n      }\n\n      .cls-13 {\n        fill: url(#linear-gradient-3);\n      }\n\n      .cls-14 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-8 {\n        opacity: .4;\n      }\n\n      .cls-9 {\n        fill: url(#Blanc_Noir-3);\n      }\n\n      .cls-9, .cls-10 {\n        opacity: .6;\n      }\n\n      .cls-10 {\n        fill: url(#Blanc_Noir-2);\n      }\n\n      .cls-15 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-11 {\n        fill: url(#Blanc_Noir-4);\n      }\n\n      .cls-16 {\n        fill: #009861;\n        font-family: AvenirLTStd-Black, 'Avenir LT Std';\n        font-size: 27.35px;\n        font-weight: 800;\n      }\n\n      .cls-17 {\n        isolation: isolate;\n      }\n\n      .cls-18 {\n        fill: url(#Blanc_Noir-5);\n      }\n\n      .cls-19 {\n        fill: url(#Blanc_Noir-6);\n      }\n\n      .cls-20 {\n        fill: url(#Blanc_Noir-7);\n      }\n\n      .cls-4, .cls-21 {\n        fill: #fff;\n      }\n\n      .cls-4, .cls-6 {\n        stroke-width: .5px;\n      }\n\n      .cls-22 {\n        opacity: .8;\n      }\n\n      .cls-23 {\n        fill: #8b95ae;\n        font-family: AvenirLTStd-Light, 'Avenir LT Std';\n        font-size: 9.12px;\n        font-weight: 300;\n      }\n\n      .cls-24 {\n        fill: #00973a;\n      }\n    "), /*#__PURE__*/React.createElement("filter", {
    id: "drop-shadow-5",
    x: 382.12,
    y: 156,
    width: 152.64,
    height: 136.8,
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 5.67,
    dy: 5.67
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    result: "blur",
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "blur",
    operator: "in"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir",
    "data-name": "Blanc, Noir",
    x1: 411.12,
    y1: 209.6,
    x2: 428.15,
    y2: 209.6,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1d1d1b"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-2",
    "data-name": "Blanc, Noir",
    x1: 437.07,
    y1: 206.56,
    x2: 431.76,
    y2: 210.74,
    xlinkHref: "#Blanc_Noir"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-3",
    "data-name": "Blanc, Noir",
    x1: 410.51,
    y1: 224.38,
    x2: 430.55,
    y2: 224.38,
    xlinkHref: "#Blanc_Noir"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-4",
    "data-name": "Blanc, Noir",
    x1: 438.27,
    y1: 223.63,
    x2: 449.94,
    y2: 223.63,
    xlinkHref: "#Blanc_Noir"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 457.55,
    y1: 207.52,
    x2: 434.37,
    y2: 227.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 434.24,
    y1: 195.07,
    x2: 418.76,
    y2: 208.67,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 443.49,
    y1: 202.21,
    x2: 427.12,
    y2: 216.59,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-5",
    "data-name": "Blanc, Noir",
    x1: 432.74,
    y1: 229.03,
    x2: 409.89,
    y2: 240.4,
    xlinkHref: "#Blanc_Noir"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-6",
    "data-name": "Blanc, Noir",
    x1: 421.25,
    y1: 205.94,
    x2: 404.98,
    y2: 214.04,
    xlinkHref: "#Blanc_Noir"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "Blanc_Noir-7",
    "data-name": "Blanc, Noir",
    x1: 426.77,
    y1: 217.02,
    x2: 403.91,
    y2: 228.39,
    xlinkHref: "#Blanc_Noir"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Calque_1",
    "data-name": "Calque 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "384.03 158.06 384.03 170.41 384.43 170.41 403.78 170.41 403.8 152.54"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M61,35.18c1.54-1.87,3.56-4.02,6.16-6.16,2.32-1.91,4.56-3.36,6.51-4.45h23.71c.9.59,2.21,1.5,3.68,2.74,6.19,5.22,9.14,11.13,11.13,15.24,5.63,11.6,8.44,17.4,10.62,22.26,2.28,5.11,5.67,12.48,10.1,21.38l21.4-52.89c.41-1.19,1.63-4.24,4.79-6.51,2.06-1.47,4.09-2.01,5.29-2.23h23.54c1.89.41,5.74,1.55,8.49,4.97,3.42,4.25,3.06,9.47,2.74,14.04-.19,2.69-.82,6.93-3.07,11.8l-41.1,72.78v53.76h-35.91c-.79-.27-1.96-.76-3.13-1.71-2.96-2.4-3.69-5.89-4.11-7.88-.25-1.18-.5-2.95-.34-5.14v-38.69L61,35.18Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M229.98,73.93c6.33,0,11.47,5.14,11.47,11.47s-5.14,11.47-11.47,11.47-11.47-5.14-11.47-11.47,5.14-11.47,11.47-11.47ZM220.09,105.56h19.77v64.06h-19.77v-64.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M316.61,160.65c-.23-.43-.44-.87-.63-1.32M317.34,161.89c-.26-.4-.5-.82-.73-1.24M357.81,163.09v-1.4h-.26c-.2.32-.41.63-.63.92M315.97,159.33c-.99-2.28-1.53-4.88-1.53-7.79,0-22.14,26.89-22.54,43.36-22.54,0-6.99-5.8-11.47-12.65-11.47-6.46,0-11.86,2.9-16.08,7.64l-10.54-10.81c7.25-6.85,17.79-10.28,28.21-10.28,23.07,0,29.26,11.73,29.26,33.08v21.79M352.93,141.65c-6.06,0-19.51.53-19.51,9.23,0,4.75,5.01,6.99,9.36,6.99,7.78,0,15.03-4.09,15.03-12v-4.22h-4.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M190.63,70.51h19.77v99.65h-19.77v-99.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M384.03,157.02v-50.87h19.77v10.28h.26c4.22-7.78,9.75-11.86,18.45-11.86,2.24,0,4.75.13,6.59.66v18.06c-2.77-.79-5.54-1.32-8.44-1.32-15.03,0-16.87,8.7-16.87,21.49v9.09"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 444.73,
    cy: 116.67,
    r: 9.12
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M289.79,159.68v-20.67c0-7.38-.13-16.87-10.28-16.87s-11.86,8.04-11.86,16.34v31.9h-19.77v-64.06h18.98v8.7h.26c2.64-5.01,9.1-10.28,18.72-10.28,20.03,0,23.72,13.18,23.72,30.32v24.88"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "289.77 159.99 289.77 170.38 309.56 170.38 309.56 159.69"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-5",
    points: "356.92 164.14 356.92 170.41 375.99 170.41 375.99 160.19"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-3",
    points: "189.77 182.41 243.2 182.41 290.22 162.66 351.72 162.66 407.27 148.69 438.05 123.82"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-21",
    d: "M411.58,190.78c-8.03-1.88-15.81-7.1-19.97-14.23-.15,7.47,1.27,15.87,4.7,22.51,1.74,3.37,3.48,7.57,7.13,10.1-1.03,5.5-2.08,15.44,1.69,26.5,6.59,19.35,24.82,32.99,44.57,36,1.72.26,31.91,4.33,51.43-18.86,2.26-2.68,16.72-20.46,12-44.57-5.21-26.62-29.2-37.49-31.71-38.57-23.63-10.21-48.48-.28-61.85,11.94-3.65,3.34-6.24,6.65-7.98,9.19Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-16",
    transform: "translate(450.77 224.58)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "H2C")), /*#__PURE__*/React.createElement("text", {
    className: "cls-23",
    transform: "translate(457.22 233.36)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "GROUP")), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M411.12,214.65s.22,2.14,1.34,1.02c1.12-1.12,3.42-5.63,10.52-8.75,7.1-3.12,4.84-3.72,4.84-3.72l-3.98.95-4.68,2.24-3.64,2.65-3.45,3.33-.8,1.86-.15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M411.12,214.65s.22,2.14,1.34,1.02c1.12-1.12,3.42-5.63,10.52-8.75,7.1-3.12,4.84-3.72,4.84-3.72l-3.98.95-4.68,2.24-3.64,2.65-3.45,3.33-.8,1.86-.15.42Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M435.11,202.64s-.66-.33-.64.19c.02.52-1.32,4.2-10.45,9.05-9.13,4.85,1.12,5.19,1.12,5.19l11.25-4.01,1.74-6.65-1.99-2.95-.54-.58-.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M435.11,202.64s-.66-.33-.64.19c.02.52-1.32,4.2-10.45,9.05-9.13,4.85,1.12,5.19,1.12,5.19l11.25-4.01,1.74-6.65-1.99-2.95-.54-.58-.49-.24Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M417.72,231.76s1.05.78,1.36-.65c.34-1.4,2.99-3.88,12.82-10.97,9.83-7.08-5.58-.75-5.58-.75l-6.84,2.11-4.35,5.47,1.87,3.91.56.75.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M417.72,231.76s1.05.78,1.36-.65c.34-1.4,2.99-3.88,12.82-10.97,9.83-7.08-5.58-.75-5.58-.75l-6.84,2.11-4.35,5.47,1.87,3.91.56.75.16.12Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M444.46,218.52l.39-.72v-.38s0-.6-.42-.22c-.42.38-1.82,1.73-8.66,9.05-6.83,7.32,2.03,2.22,2.03,2.22l5.18-4.35,1.8-4.46-.31-1.14Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M444.46,218.52l.39-.72v-.38s0-.6-.42-.22c-.42.38-1.82,1.73-8.66,9.05-6.83,7.32,2.03,2.22,2.03,2.22l5.18-4.35,1.8-4.46-.31-1.14Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M423.16,230.82c1.62-1.06,4-2.07,5.91-2.89,8.71-3.72,15.03-6.7,15.78-10.52,0,.21.01.41.01.62,0,9.41-7.63,17.04-17.04,17.04-1.9,0-3.72-.31-5.43-.88-1.66-.82-1.4-1.95.77-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M427.81,201c1.12,0,2.21.11,3.27.31.86.32,1.05.8.5,1.42-.85.94-3.06,1.86-6.4,3.26-7.52,3.15-12.67,5.5-14.07,8.66,1.57-7.79,8.45-13.65,16.7-13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-24",
    d: "M427.86,222.85c-7.99,3.53-12.51,6.31-10.14,8.91-3.38-2.49-5.81-6.21-6.63-10.5.26-4.11,7.33-7.51,15.82-11.2,5.94-2.58,11.37-5.26,8.2-7.43,3.69,1.75,6.66,4.79,8.31,8.55.56,3.23-3.85,6.49-15.55,11.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-22"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M423.16,230.82c1.62-1.06,4-2.07,5.91-2.89,8.71-3.72,15.03-6.7,15.78-10.52,0,.21.01.41.01.62,0,9.41-7.63,17.04-17.04,17.04-1.9,0-3.72-.31-5.43-.88-1.66-.82-1.4-1.95.77-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-14",
    d: "M427.81,201c1.12,0,2.21.11,3.27.31.86.32,1.05.8.5,1.42-.85.94-3.06,1.86-6.4,3.26-7.52,3.15-12.67,5.5-14.07,8.66,1.57-7.79,8.45-13.65,16.7-13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M427.86,222.85c-7.99,3.53-12.51,6.31-10.14,8.91-3.38-2.49-5.81-6.21-6.63-10.5.26-4.11,7.33-7.51,15.82-11.2,5.94-2.58,11.37-5.26,8.2-7.43,3.69,1.75,6.66,4.79,8.31,8.55.56,3.23-3.85,6.49-15.55,11.67Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-18",
    d: "M423.16,230.82c1.62-1.06,4-2.07,5.91-2.89,8.71-3.72,15.03-6.7,15.78-10.52,0,.21.01.41.01.62,0,9.41-7.63,17.04-17.04,17.04-1.9,0-3.72-.31-5.43-.88-1.66-.82-1.4-1.95.77-3.37Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-19",
    d: "M427.81,201c1.12,0,2.21.11,3.27.31.86.32,1.05.8.5,1.42-.85.94-3.06,1.86-6.4,3.26-7.52,3.15-12.67,5.5-14.07,8.66,1.57-7.79,8.45-13.65,16.7-13.65Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M427.86,222.85c-7.99,3.53-12.51,6.31-10.14,8.91-3.38-2.49-5.81-6.21-6.63-10.5.26-4.11,7.33-7.51,15.82-11.2,5.94-2.58,11.37-5.26,8.2-7.43,3.69,1.75,6.66,4.79,8.31,8.55.56,3.23-3.85,6.49-15.55,11.67Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlancH2C);
export default __webpack_public_path__ + "static/media/Blanc-H2C.b39cc616da8bd189a90896a629aa4b9b.svg";
export { ForwardRef as ReactComponent };